import { render, staticRenderFns } from "./update-faq.vue?vue&type=template&id=315ff224&scoped=true&"
import script from "./update-faq.vue?vue&type=script&lang=js&"
export * from "./update-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ff224",
  null
  
)

export default component.exports